import { FC } from 'react';

interface DataGridImageTemplateProps {
  imageSrc: string;
}

const DataGridImageTemplate: FC<DataGridImageTemplateProps> = (props) => {
  const validImage = new RegExp(`^(https?:\\/\\/.*\\.(?:png|jpg|gif))$`);

  if (validImage.test(props.imageSrc)) {
    return <img src={props.imageSrc} alt="" className="DataGrid-Image" />;
  } else {
    return <></>;
  }
};

export default DataGridImageTemplate;
